import { FIELD_IDS } from "./constants";

export const getCustomFieldValue = (customFields, fieldId) => {
  if (!customFields || !Array.isArray(customFields)) return "";
  const field = customFields.find((f) => f.id === fieldId);
  return field?.value || "";
};

export const parsePipeList = (value) => {
  if (!value) return [];
  if (typeof value === "string") {
    return value
      .split(/[|,]/)
      .map((item) => item.trim())
      .filter((item) => item);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [];
};

export const ensureHttpProtocol = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `https://${url}`;
};

export const extractPractitionerData = (mergedUser, decodedName) => {
  const getField = (fieldId) =>
    getCustomFieldValue(mergedUser?.customFields, fieldId);

  return {
    fullName:
      mergedUser?.name ||
      `${mergedUser?.firstName || ""} ${mergedUser?.lastName || ""}`.trim() ||
      decodedName,
    firstName: mergedUser?.firstName || "",
    lastName: mergedUser?.lastName || "",
    email: mergedUser?.email || "",
    phone: mergedUser?.phone || "",
    address: mergedUser?.address1 || "",
    bio: getField(FIELD_IDS.bio) || mergedUser?.bio || "",
    fullBio: getField("fullBio") || mergedUser?.fullBio || "",
    personalStory: getField("personalStory") || mergedUser?.personalStory || "",
    title: getField("title") || mergedUser?.title || "",
    specialties: mergedUser?.specialities,
    education: getField(FIELD_IDS.education) || mergedUser?.education || "",
    certifications:
      getField(FIELD_IDS.certifications) || mergedUser?.certifications || "",
    memberships:
      getField(FIELD_IDS.memberships) || mergedUser?.memberships || "",
    practitionerTypes:
      getField("practitionerTypes") || mergedUser?.practitionerTypes || "",
    languages: getField(FIELD_IDS.languages) || mergedUser?.languages || "",
    experience: getField(FIELD_IDS.experience) || mergedUser?.experience || "",
    website: getField(FIELD_IDS.website) || mergedUser?.website || "",
    linkedin: getField(FIELD_IDS.linkedin) || mergedUser?.linkedin || "",
    instagram: getField(FIELD_IDS.instagram) || mergedUser?.instagram || "",
    twitter: getField(FIELD_IDS.twitter) || mergedUser?.twitter || "",
    facebook: getField(FIELD_IDS.facebook) || mergedUser?.facebook || "",
    hasCalendar: mergedUser?.hasCalendar || false,
    calendars: mergedUser?.calendars || [],
    primaryCalendar: mergedUser?.primaryCalendar || null,
    userId: mergedUser?.userId,
    avatar: mergedUser?.avatar || null,
    avatarPosition: mergedUser?.avatarPosition || "", // object-position chosen in the dashboard
    hourlyRate: getField(FIELD_IDS.hourlyRate) || mergedUser?.hourlyRate || "",
  };
};

export const buildGhlCalendarUrl = (calendarId, patientData) => {
  if (!calendarId) return "";
  const baseUrl = `https://api.leadconnectorhq.com/widget/booking/${calendarId}`;
  if (!patientData?.email) return baseUrl;
  const params = new URLSearchParams();
  if (patientData.firstName) params.append("first_name", patientData.firstName);
  if (patientData.lastName) params.append("last_name", patientData.lastName);
  if (patientData.email) params.append("email", patientData.email);
  if (patientData.phone) params.append("phone", patientData.phone);
  return `${baseUrl}?${params.toString()}`;
};
